import { useEffect } from "react";
import { useStore } from "react-redux";

import useWebSocket from "react-use-websocket";

import { eventTypes, eventActions } from "../../socketConstants";
import { QUEUES } from "../../constants";

import {
    uploadDenied,
    uploadVisuallyPublished,
    uploadFullyPublished,
    setGemStatusToTrue,
    setGemStatusToFalse,
    setMatureToTrue,
    setMatureToFalse,
    setExplicitStatusToFalse,
    needsReleaseStatusSetToFalse,
    editorialUseOnlySetToFalse,
    hasWarningTextSetToFalse
} from "../../slices/uploadsSlice";

import { unblurUpload } from "../../slices/uploadFooterActionsSlice";
import { BatchThunks } from "frontend/components/fort/mod/photos/slices/batchesSlice";
import { messagesSlice } from "frontend/components/fort/mod/photos/slices/messagesSlice.js";

const usePhotoModWebSocket = () => {
    const store = useStore();
    const { lastJsonMessage: event } = useWebSocket(
        `${window.location.protocol === "https:" ? "wss" : "ws"}://${
            window.location.host
        }/websockets/photo-uploads/moderation/`,
        {
            onClose: () => {
                store.dispatch(
                    messagesSlice.actions.addMessage({
                        text:
                            "A connection error has occurred. Please close then return to the page to continue.",
                        timed: false
                    })
                );
            }
        }
    );

    useEffect(() => {
        if (!event) return;

        if (event.type === eventTypes.BATCH_MODERATION_NOTE) {
            if (
                event.data.action === eventActions.CLAIMED_BATCH ||
                event.data.action === eventActions.RELEASED_CLAIM_ON_BATCH ||
                event.data.action.match(eventActions.BATCH_ASSIGNED) ||
                event.data.action.match(
                    eventActions.REMOVED_BATCH_ASSIGNMENT
                ) ||
                event.data.action === eventActions.MARKED_BATCH_AS_COMPLETE
            ) {
                let moderationType = "";

                if (store.getState().currentQueue.name === QUEUES.VIS_MOD) {
                    moderationType = "VISUAL";

                    // TODO: Disabling for now. Need to listen for moderator changes and refetch batches based on current page

                    // store.dispatch(
                    //     BatchThunks.fetchBatches({
                    //         moderationType
                    //     })
                    // );
                }

                if (
                    store.getState().currentQueue.name === QUEUES.METADATA_MOD
                ) {
                    moderationType = "METADATA";

                    // TODO: Disabling for now. Need to listen for moderator changes and refetch batches based on current page
                    // store.dispatch(
                    //     BatchThunks.fetchBatches({
                    //         moderationType
                    //     })
                    // );
                }
            }
        }

        if (event.type === eventTypes.MODERATION) {
            const photoUploadId = event.data.photoUploadId.toString();

            if (event.data.action === eventActions.SET_GEM_STATUS_TO_TRUE) {
                return store.dispatch(setGemStatusToTrue(photoUploadId));
            }

            if (event.data.action === eventActions.SET_GEM_STATUS_TO_FALSE) {
                return store.dispatch(setGemStatusToFalse(photoUploadId));
            }

            if (event.data.action === eventActions.SET_MATURE_TO_TRUE) {
                return store.dispatch(setMatureToTrue(photoUploadId));
            }

            if (event.data.action === eventActions.SET_MATURE_TO_FALSE) {
                return store.dispatch(setMatureToFalse(photoUploadId));
            }

            if (
                event.data.action === eventActions.SET_EXPLICIT_STATUS_TO_FALSE
            ) {
                return store.dispatch(setExplicitStatusToFalse(photoUploadId));
            }

            if (
                event.data.action ===
                eventActions.SET_NEEDS_RELEASE_STATUS_TO_FALSE
            ) {
                return store.dispatch(
                    needsReleaseStatusSetToFalse(photoUploadId)
                );
            }

            if (
                event.data.action ===
                eventActions.SET_EDITORIAL_USE_ONLY_TO_FALSE
            ) {
                return store.dispatch(
                    editorialUseOnlySetToFalse(photoUploadId)
                );
            }

            if (
                event.data.action === eventActions.SET_HAS_WARNING_TEXT_TO_FALSE
            ) {
                return store.dispatch(hasWarningTextSetToFalse(photoUploadId));
            }
        }
    }, [event]);

    return null;
};

export default usePhotoModWebSocket;
